<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Group" :required="true">
              <b-form-select
                @blur="$v.product.product_group_id.$touch"
                :class="{ 'is-invalid': $v.product.product_group_id.$error }"
                v-model="product.product_group_id"
                :options="productGroups"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.product.product_group_id.required"
              >
                Please select group
              </div>
            </form-group>
            <form-group label="Supplier" :required="true">
              <b-form-select
                @blur="$v.product.supplier_id.$touch"
                :class="{ 'is-invalid': $v.product.supplier_id.$error }"
                v-model="product.supplier_id"
                :options="suppliers"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.product.supplier_id.required"
              >
                Please select supplier
              </div>
            </form-group>
            <form-group label="Brand" :required="true">
              <b-form-select
                @blur="$v.product.brand_id.$touch"
                :class="{ 'is-invalid': $v.product.brand_id.$error }"
                v-model="product.brand_id"
                :options="brands"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.product.brand_id.required"
              >
                Please select brand
              </div>
            </form-group>

            <form-group label="Code" :required="true">
              <input
                @change="checkDuplicate()"
                @blur="$v.product.code.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.product.code.$error }"
                v-model="product.code"
                v-uppercase
              />
              <div class="invalid-feedback" v-if="!$v.product.code.required">
                Please enter code
              </div>

               <div class="text-danger"  v-if="product.duplicate == true">
                DUPLICATE PRODUCT CODE
              </div>

            </form-group>

           

            <form-group label="Name" :required="true">
              <input
                @blur="$v.product.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.product.name.$error }"
                v-model="product.name"
              />
              <div class="invalid-feedback" v-if="!$v.product.name.required">
                Please enter name
              </div>
            </form-group>

            <form-group label="Description">
              <textarea-autosize
                class="form-control"
                v-model="product.description"
              />
            </form-group>

            <form-group label="Min (Mandate)" :required="true">
              <input
                type="number"
                min="0"
                @blur="$v.product.mandate_pricing_min.$touch"
                class="form-control w-50"
                :class="{ 'is-invalid': $v.product.mandate_pricing_min.$error }"
                v-model="product.mandate_pricing_min"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.product.mandate_pricing_min.required"
              >
                Please enter price
              </div>
            </form-group>

            <form-group label="Max (List Price)">
              <input
                type="number"
                min="0"
                class="form-control w-50"
                v-model="product.mandate_pricing_max"
              />
            </form-group>

            <div v-if="canManagePricing" class="mb-4 border-top pt-3">
              <h5>Branch pricing</h5>
              <product-branch-prices ref="branchPrices" v-model="branchPriceChanges" :branches="branches"
                :defaults="product" :loading="optionsLoading" :load-error="optionsError" :errors="errors" @retry="getData" />
            </div>

            <form-group label="Vatable">
              <b-form-checkbox
                v-model="product.is_vatable"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Average Mass">
              <input
                type="number"
                min="0"
                class="form-control w-50"
                v-model="product.average_mass"
              />
            </form-group>

            <form-group label="Price Extended By Mass">
              <b-form-checkbox
                v-model="product.price_extended_by_mass"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

             <form-group label="Promote">
              <b-form-checkbox
                v-model="product.on_promotion"
                value="1"
                unchecked-value="0"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            
             <form-group label="Cases Per Pallet">
              <input
                type="number"
                min="0"
                class="form-control w-50"
                v-model="product.cases_per_pallet"
              />
            </form-group>

            <form-group label="Image">
              <image-upload @files-uploaded=" product.image_id = $event;
              imageUploading = false; " @files-uploaded-started="imageUploading
              = true" :multiple="false" :imageCrop=true :imageCropRatio=1/1
              :validationState="imageVstate" acceptedTypes="image/*" />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import productRepo from "@/api/repos/productRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";
import productBranchPrices from "@/components/products/ProductBranchPrices";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
    productBranchPrices,
  },

  computed: {
    canManagePricing() { return this.userHasPerms(['Manage pricing']); },
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    product: {
      code: {
        required,
      },
      name: {
        required,
      },
      mandate_pricing_min: {
        required,
      },
      product_group_id: {
        required,
      },
      brand_id: {
        required,
      },
      supplier_id: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      product: {
        duplicate:false,
        is_vatable:1,
        mandate_pricing_min: null,
        mandate_pricing_max: null,
      },
      branches: [],
      branchPriceChanges: [],
      optionsLoading: false,
      optionsError: '',
      productGroups: [],
      brands: [],
      suppliers: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      this.optionsLoading = true;
      this.optionsError = '';
      try {
        let { data } = await productRepo.createGetData();
        this.productGroups = data.product_groups;
        this.suppliers = data.suppliers;
        this.brands = data.brands;
        this.branches = data.branches || [];
      } catch (error) {
        this.optionsError = 'Could not load product options. Please try again.';
      } finally {
        this.optionsLoading = false;
      }
    },
    async checkDuplicate(){
      try {
          let {data} = await productRepo.checkDuplicate(this.product.code);
           if(data.duplicate == 'true'){
             this.product.duplicate = true;
           }else{
             this.product.duplicate = false;
           }

        } catch (error) {
          console.log(error)
        }
    },
    async handleSubmit() {
      if (this.$refs.branchPrices && !this.$refs.branchPrices.validate()) return;
      this.errors = null;
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          const payload = { ...this.product };
          if (this.canManagePricing && this.branchPriceChanges.length) payload.branch_prices = this.branchPriceChanges;
          await productRepo.create(payload);
          this.$emit("productCreated");
        } catch (error) {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.errors = { product: [(error.response && error.response.data.message) || 'Could not save the product. Please try again.'] };
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

